import { useLocation } from "react-router-dom";
import { Avatar, Stack, Typography } from "@mui/material";
import Menu from "./Menu";
import ShowWhen from "../../Other/ShowWhen";
import ObjectIcon from "../../ObjectIcon";
import { colorMix } from "../../../theme/AppTheme";
import { toCapitalize } from "../../../utils/text-format";
import { isAdmin } from "../../../utils/session";
import { useObjects } from "../../../context/ObjectsContext";
import { ADMIN_OPTIONS, GENERAL_OPTIONS } from "./options";

export default function MenuSection() {
    const { pathname } = useLocation();
    const { objects } = useObjects();

    /* The org's own objects — the nav is whatever the tenant defined. */
    const objectOptions = objects
        .filter((o) => o.showInNav !== false)
        .map((o) => ({
            label: o.name,
            icon: <ObjectIcon name={o.icon} size={18} />,
            path: `/o/${o.slug}`,
        }));

    const firstName = localStorage.getItem("firstName") || "User";
    const roleName = (localStorage.getItem("roleName") || "").replace(
        /_/g,
        " ",
    );

    return (
        <Stack sx={{ height: "100%", width: "100%" }}>
            <Stack
                className="sidebar-padding"
                sx={{
                    position: "sticky",
                    top: 0,
                    backdropFilter: "blur(10px)",
                    zIndex: 1,
                }}
            >
                <Stack
                    sx={{
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "12px",
                        borderRadius: "4px",
                        padding: "8px",
                        bgcolor: "var(--primary)",
                        width: "100%",
                    }}
                >
                    <Avatar
                        sx={{
                            height: "40px",
                            width: "40px",
                            borderRadius: "3px",
                            color: "var(--primary-contrast)",
                            backgroundColor: colorMix(
                                "var(--primary)",
                                80,
                                "var(--primary-contrast)",
                            ),
                        }}
                    >
                        {firstName[0].toUpperCase()}
                    </Avatar>

                    <Stack sx={{ gap: "4px" }}>
                        <Typography
                            sx={{
                                color: "var(--primary-contrast)",
                                fontWeight: "600",
                                lineHeight: 1,
                                textTransform: "capitalize",
                            }}
                        >
                            {toCapitalize(firstName)}
                        </Typography>
                        <Typography
                            sx={{
                                color: "var(--primary-contrast)",
                                fontSize: "12px",
                                lineHeight: 1,
                                textTransform: "capitalize",
                                opacity: 0.75,
                            }}
                        >
                            {toCapitalize(roleName)}
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>

            <Stack className="sidebar-padding" gap={3}>
                <Menu
                    title="General"
                    options={GENERAL_OPTIONS}
                    isActive={(path) => pathname.startsWith(path)}
                />

                <ShowWhen when={objectOptions.length > 0}>
                    <Menu
                        title="Objects"
                        options={objectOptions}
                        isActive={(path) => pathname.startsWith(path)}
                    />
                </ShowWhen>

                <ShowWhen when={isAdmin()}>
                    <Menu
                        title="Admin"
                        options={ADMIN_OPTIONS}
                        isActive={(path) => pathname.startsWith(path)}
                    />
                </ShowWhen>
            </Stack>
        </Stack>
    );
}
